import { LocationListEntity } from "./LocationListEntity";

interface PeopleEntity {
  name: string;
  phone: string;
  position: string;
}

export interface LocationEntity extends LocationListEntity {
  bmName: string;
  address: string;
  phone: string;
  ext: string;
  email: string;
  manager: PeopleEntity;
  personInCharge: PeopleEntity[];
  vision: string;
  mission: string[];
  strategy: string[];
  imageName: string;
  imageUrl: string;
  instagram?: string;
  facebook?: string;
  tiktok?: string;
  youtube?: string;
}

export namespace LocationEntity {
  export function fromJson(data: any): LocationEntity {
    return {
      address: data.address,
      bmName: data.bmName,
      ext: data.ext,
      email: data.email,
      imageName: data.imageName,
      imageUrl: data.imageURL,
      locationId: data.locationID,
      locationName: data.locationName,
      manager: {
        name: data.manager.name,
        phone: data.manager.phone,
        position: data.manager.position,
      },
      mission: data.mission,
      personInCharge: data.personInCharge.map(
        (e): PeopleEntity => ({
          name: e.name,
          phone: e.phone,
          position: e.position,
        })
      ),
      phone: data.phone,
      strategy: data.strategy,
      vision: data.vision,
      facebook: data.facebook,
      instagram: data.instagram,
      tiktok: data.tiktok,
      youtube: data.youtube,
    };
  }
}
